//Reference: EN121

import { Mappeable } from './mappeable.model';
import moment from 'moment';
import * as _ from 'lodash';

export class Parameter extends Mappeable {
    idParameterPk: number;
    txtValor: string;
    txtComment: string;
    mrkActive: boolean;
    dateInsert: string;
    userInsert: string;


    constructor(o) {
        super(o);
        this.dateInsert = moment(this.dateInsert, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.mrkActive = _.isUndefined(this.mrkActive) || _.isNull(this.mrkActive) ? false : this.mrkActive;
    }

    public mapToBack() {
        return {
            mrkActive: this.mrkActive,
            txtComment: this.txtComment,
            txtValor: this.txtValor
        }
    }


}